{
	"dependencies": {
		"@mairistem/assistant": "^0.3.2",
		"@mairistem/composants": "0.8.1",
		"@mairistem/comptabilite": "^0.4.92",
		"@mairistem/finances-utils": "^0.5.43",
		"@mairistem/module": "^0.9.0",
		"@mairistem/tools": "^0.4.9",
		"@sentry/react": "^10.53.1",
		"lodash": "^4.17.21",
		"react": "^18.2.0",
		"react-dom": "^18.2.0",
		"react-dropzone": "^14.3.8",
		"react-router": "^5.2",
		"react-router-dom": "^5.2",
		"react-toastify": "^9.1.3"
	},
	"devDependencies": {
		"@biomejs/biome": "^2.4.9",
		"@testing-library/jest-dom": "^6.6.3",
		"@testing-library/react": "16.2.0",
		"@testing-library/user-event": "14.6.1",
		"@types/bun": "^1.3.12",
		"@types/lodash": "^4.14.202",
		"@types/react": "^18.2.55",
		"@types/react-dom": "^18.2.19",
		"@types/react-router": "^5.1.20",
		"@types/react-router-dom": "^5.3.3",
		"@vitejs/plugin-react": "^6.0.1",
		"@vitest/coverage-v8": "^4.0.18",
		"esbuild": "^0.28.0",
		"happy-dom": "^20.9.0",
		"typescript": "~6",
		"vite": "^8.0.9",
		"vitest": "^4.1.0"
	},
	"license": "Proprietary",
	"name": "app-administration-ixchange",
	"scripts": {
		"build": "NODE_OPTIONS='--max-old-space-size=8096' vite build",
		"build:app": "NODE_OPTIONS='--max-old-space-size=8096' vite build --mode app",
		"lint": "biome check .",
		"lint:fix": "biome check --write .",
		"start": "NODE_ENV=development vite dev",
		"test": "vitest",
		"test:unit": "vitest run"
	},
	"type": "module",
	"version": "0.13.0"
}
